import { render, staticRenderFns } from "./CardNotifications.vue?vue&type=template&id=5a97801a&scoped=true&"
import script from "./CardNotifications.vue?vue&type=script&lang=js&"
export * from "./CardNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CardNotifications.vue?vue&type=style&index=0&id=5a97801a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97801a",
  null
  
)

export default component.exports